import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubSearchPage]'})
export class SearchPageDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
